// @module StellarGrade.ST_Facets.Facets
define('StellarGrade.ST_Facets.Facets.View', 
    ['Facets.FacetedNavigationItem.View', 
        'underscore'], function (FacetedNavigationItem, _) {
    'use strict';

    return {
        loadModule: function () {
            _.extend(FacetedNavigationItem.prototype, {
                // Set default filter to selected industries from "SHOP BY INDUSTRIES" navigation header
                getContext: _.wrap(FacetedNavigationItem.prototype.getContext, function wrapper(fn) {
                    const facetId = 'custitem_soc_industries';
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    var SANDBOX = false;
                    var linkToRemove = '/Industries/'
                    
                    if (context.facetId == facetId) {
                        if (SANDBOX) {
                            linkToRemove = '/INDUSTRIES/'
                        }
                        var selectedIndustries = context.removeLink.replace(linkToRemove, '').trim().toLowerCase();
                        // console.log('selectedIndustries: ', selectedIndustries);
                        for (var i = 0; i < context.values.length; i++) {
                            var displayName = context.values[i].displayName.trim().toLowerCase();
                            // console.log('displayName: ', {displayName: displayName, selectedIndustries: selectedIndustries});

                            if (displayName.includes('/')) {
                                var displayParts = displayName.split('/');
                                var isMatch = displayParts.some((part) => selectedIndustries === part.trim());
                                if (isMatch) {
                                    context.values[i].isActive = true;
                                }
                            } else if (selectedIndustries == displayName) {
                                context.values[i].isActive = true;
                            }
                        }
                    }

                    // Change <a></a> into <p></p> for active elements
                    setTimeout(function () {
                        var activeElements = document.querySelectorAll('.facets-faceted-navigation-item-facet-option.option-active');

                        activeElements.forEach(function (element) {
                            if (element.tagName.toLowerCase() === 'a') {
                                var inputElement = element.querySelector('input');
                                if (inputElement) {
                                    inputElement.checked = true; 
                                    inputElement.disabled = true;
                                }

                                var preplacedElement = document.createElement('p');

                                preplacedElement.className = element.className;
                                preplacedElement.innerHTML = element.innerHTML;

                                element.parentNode.replaceChild(preplacedElement, element);
                            }
                        });
                    }, 0);
                    return context;
                }),
            });
        },
    };
});
